// Backwards-compat shim: existing call sites use <StatusPill value=… />.
// We now delegate to the global StatusBadge to upgrade every legacy pill
// app-wide to the Power BI palette without touching individual pages.
import StatusBadge from "@/components/common/StatusBadge";
import { getStatusTone } from "@/utils/statusTheme";

// Auto-infer the badge type from common token shapes
function inferType(v) {
  if (!v) return "generic";
  const s = String(v).toUpperCase();
  if (["HEALTHY", "AT_RISK", "WARNING"].includes(s)) return "health";
  if (["LOW", "NORMAL", "HIGH", "URGENT"].includes(s)) return "priority";
  if (["NOT_INVOICED", "INVOICED", "PAID", "PARTIALLY_PAID", "PAYMENT_BLOCKED",
       "OVERDUE", "UNALLOCATED", "ALLOCATED", "PARTIALLY_ALLOCATED"].includes(s)) return "payment";
  if (["DRAFT", "ISSUED", "CREDITED_PARTIAL", "CREDITED_FULL"].includes(s)) return "invoice";
  if (["SENT", "ACCEPTED", "REJECTED", "EXPIRED", "REVISED", "APPROVAL_REQUIRED",
       "CONVERTED_TO_CASE", "INTERNAL_REVIEW"].includes(s)) return "quotation";
  if (["NEW", "CONTACTED", "QUALIFIED", "QUOTED", "WON", "LOST", "CONVERTED",
       "DUPLICATE_SUSPECTED"].includes(s)) return "lead";
  if (["REQUIRED", "REQUESTED", "UPLOADED", "UNDER_REVIEW", "APPROVED", "WAIVED",
       "NOT_APPLICABLE", "SUPERSEDED", "VIRUS_SCAN_FAILED", "UPLOAD_FAILED"].includes(s)) return "document";
  if (["PACKAGE_DRAFT", "INTERNAL_APPROVAL_PENDING", "SUBMITTED", "AWAITING_RESPONSE",
       "CLARIFICATION_OPEN", "RESUBMITTED", "PARTIALLY_APPROVED", "ADDITIONAL_FEE_REQUIRED",
       "WITHDRAWN"].includes(s)) return "submission";
  if (["OPEN", "DEFERRED", "CONVERTED_TO_QUOTATION", "SURVEILLANCE_DUE"].includes(s)) return "renewal";
  if (["CREATED", "ACTIVE", "BLOCKED", "ON_HOLD", "BLOCKED_DEPENDENCY",
       "FINALIZED", "CLOSED", "CANCELLED", "REOPENED", "IN_PROGRESS"].includes(s)) return "case";
  if (["INVITED", "INACTIVE", "SUSPENDED", "LOCKED", "PASSWORD_RESET_REQUIRED"].includes(s)) return "user";
  return "generic";
}

export const STATUS_MAP = {};

export function StatusPill({ value, className = "", showDot = true, type, ...rest }) {
  if (value == null || value === "") return null;
  const inferred = type || inferType(value);
  return <StatusBadge status={value} type={inferred} showDot={showDot} className={className} {...rest} />;
}

export function HealthDot({ value }) {
  const tone = getStatusTone(value, "health");
  return <span className={`inline-block w-2 h-2 rounded-full ${tone.dot}`} title={value || ""} />;
}
